export enum System {
  keySep = '->'
}
